import {
    UpdateEpiContextActionTypes,
    UPDATE_LANGUAGE,
    UPDATE_VALUTA,
    UPDATE_EPIMODEL,
    UpdateEpiEditContext,
    UpdateEpiValutaAction,
    UPDATE_CONTEXT,
    EpiEditContext,
    UpdateZIndex,
    UPDATE_ZINDEX,
} from './Types';

export function updateEpiModel<T>(newModel: T, timestamp: number, feilet: boolean): UpdateEpiContextActionTypes<T> {
    return {
        type: UPDATE_EPIMODEL,
        payload: {
            epiModel: newModel,
            epiModelTimestamp: timestamp,
            epiModelFeilet: feilet,
        },
    };
}

export function updateValuta<T>(valuta: string): UpdateEpiValutaAction<T> {
    return {
        type: UPDATE_VALUTA,
        payload: valuta,
    };
}

export function updateLanguage<T>(locale: string): UpdateEpiContextActionTypes<T> {
    return {
        type: UPDATE_LANGUAGE,
        payload: locale,
    };
}

export function updateEpiEditContext(epiEditContext: Partial<EpiEditContext>): UpdateEpiEditContext {
    return {
        type: UPDATE_CONTEXT,
        payload: epiEditContext,
    };
}

export function updateZIndex(zIndex: number): UpdateZIndex {
    return {
        type: UPDATE_ZINDEX,
        payload: zIndex,
    };
}
